import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {WRTCProviderService} from '@app/modules/wrtc/services/providers/wrtc-provider';
import {AccessType, LogLevel, LogResource} from '@app/modules/shared/data/constants';
import {LogService} from '@app/services/log.service';
import {RemoteParticipantInfo} from '@app/models/remote-participant-info';
import {ClassroomAction, ClassroomState, ClassroomStateModel} from '@app/state/classroom-state.service';
import {Store} from '@ngxs/store';
import {WrtcService} from '@app/modules/wrtc/services/wrtc.service';
import {LocalUser, LocalUserState} from '@app/state/local-user.state';

@Component({
  selector: 'app-remote-teacher',
  templateUrl: './remote-teacher.component.html'
})
export class RemoteTeacherComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() teacher: RemoteParticipantInfo;
  public classroom: ClassroomStateModel;
  public localUser: LocalUser;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public AccessType = AccessType;

  constructor(private wrtcProviderService: WRTCProviderService, private store: Store, private wrtcService: WrtcService, private mediaWrapper: ElementRef<HTMLElement>) {
  }

  ngOnInit(): void {
    this.store.select(ClassroomState).subscribe((classroom: ClassroomStateModel) => {
      this.classroom = classroom;
    });
    this.store.select(LocalUserState).subscribe((localUser: LocalUser) => {
      this.localUser = localUser;
    });
  }

  ngAfterViewInit(): void {
    this.wrtcProviderService.addRemoteParticipantInfo(this.teacher.id, AccessType.TEACHER, this.mediaWrapper.nativeElement);
    LogService.writeLog(`Remote teacher ${this.teacher.displayName} component  is loaded`, LogLevel.DEBUG, LogResource.CORE);
  }

  ngOnDestroy(): void {
    this.wrtcProviderService.removeRemoteParticipantMediaWrappers(this.teacher.id);
  }

  public handleClassroomUnmuteButtonClick(): void {
    this.store.dispatch(new ClassroomAction.ToggleRoomMutedBecauseOfBlockedMicAnCam(false));
    this.wrtcService.dropRoomMuteBecauseOfBlockedMicAndCam();
  }
}
